import { Controller } from "@hotwired/stimulus";

// Shows the chosen file's name in a styled upload label (since the real <input> is hidden).
export default class extends Controller {
  static targets = ["name", "input"];
  static values = { placeholder: String };

  display() {
    const file = this.inputTarget.files[0];
    this.nameTarget.textContent = file ? file.name : this.placeholderValue;
  }
}
